// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.

export const reportPaths = {
    pdf: () => 'admin/reports/pdf',
};
